namespace TabAurous.OMS {
    export interface FixedRateMasterForm {
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        FromWt: Serenity.DecimalEditor;
        ToWt: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        PurchaseRate: Serenity.DecimalEditor;
        SalesRate: Serenity.DecimalEditor;
    }

    export class FixedRateMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.FixedRateMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FixedRateMasterForm.init)  {
                FixedRateMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;

                Q.initFormType(FixedRateMasterForm, [
                    'ProductId', w0,
                    'AttributeId', w0,
                    'FromWt', w1,
                    'ToWt', w1,
                    'FromDate', w2,
                    'ToDate', w2,
                    'PurchaseRate', w1,
                    'SalesRate', w1
                ]);
            }
        }
    }
}
